import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { useEffect } from "react";
import { getNotifications } from "services/apiService";
import MDAvatar from "components/MDAvatar";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import SuggestionList from "layouts/suggestionBox";
import InfiniteScroll from "react-infinite-scroll-component";
import SpinLoader from "components/SpinLoader";

function Notifications() {
  let navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);

  const [pageNumber, setPageNumber] = useState(0);
  const [hasMoreBoolean, setHasMoreBoolean] = useState(false);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const notificationStatements = {
    Like: "liked your post",
    Comment: "commented on your post",
    Following: "started following you",
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    const getNotificationsRes = await getNotifications(pageNumber);
    // console.log("getNotificationsRes", getNotificationsRes);

    console.log("getNotificationsRes", getNotificationsRes.length);

    if (getNotificationsRes.length >= 10) {
      setHasMoreBoolean(true);
    } else {
      setHasMoreBoolean(false);
    }
    setNotifications(getNotificationsRes);
  };

  const handleUsernameClick = (username) => {
    navigate(`/profile/?username=${username}`);
  };

  const handleNavigatePost = (postId) => {
    navigate(`/post-details/?p_source=${postId}`);
  };

  const fetchMoreData = async (newPageNumber) => {
    setPageNumber(newPageNumber);
    const getNotificationsResNew = await getNotifications(newPageNumber);
    // console.log("getNotificationsRes", getNotificationsRes);

    console.log("getNotificationsResNEw", getNotificationsResNew.length);

    if (getNotificationsResNew.length >= 10) {
      setHasMoreBoolean(true);
      setNotifications(notifications.concat(getNotificationsResNew));
    } else {
      setHasMoreBoolean(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} sx={{ paddingTop: 0 }}>
        <MDBox mt={4.5}>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={6} lg={6}>
              <InfiniteScroll
                dataLength={notifications.length}
                next={() => fetchMoreData(pageNumber + 1)}
                hasMore={hasMoreBoolean}
                loader={
                  <MDBox sx={{ marginTop: "1rem", textAlign: "center" }}>
                    <SpinLoader />
                  </MDBox>
                }
              >
                <MDBox>
                  {notifications.map((item, idx) => (
                    <MDBox
                      key={idx}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      marginBottom="1rem"
                    >
                      <MDBox display="flex" gap="0.5rem" alignItems="center">
                        <MDBox>
                          <MDAvatar
                            src={item.user[0].pic}
                            sx={{ fontWeight: "bold", cursor: "pointer" }}
                            imgProps={{
                              style: { height: "100%", width: "100%" },
                            }}
                            onClick={() =>
                              handleUsernameClick(item.user[0].username)
                            }
                          />
                        </MDBox>
                        <MDBox>
                          <MDBox>
                            <MDTypography
                              // variant="button"
                              sx={{ lineHeight: "20px", cursor: "pointer" }}
                              fontSize="15px"
                              fontWeight="bold"
                              onClick={() =>
                                handleUsernameClick(item.user[0].username)
                              }
                            >
                              {item.user[0].username}{" "}
                              <MDTypography
                                // variant="button"
                                sx={{ lineHeight: "20px", display: "inline" }}
                                fontSize="15px"
                                fontWeight="light"
                              >
                                {notificationStatements[item.key]}
                              </MDTypography>
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <MDTypography
                              fontSize="15px"
                              color="text"
                              fontWeight="regular"
                            >
                              <Moment fromNow>{item.timeStamp}</Moment>
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                      <MDBox
                        sx={{
                          display: "flex",
                          justifyContent: "end",
                          width: "80px",
                        }}
                      >
                        {item.post ? (
                          <MDAvatar
                            src={
                              item.post.postType === "image"
                                ? item.post.photo
                                : item.post.thumbnail
                            }
                            sx={{ fontWeight: "bold", borderRadius: "0%" }}
                            imgProps={{
                              style: { height: "100%", width: "100%" },
                            }}
                            onClick={() => handleNavigatePost(item.post._id)}
                          />
                        ) : null}
                      </MDBox>
                    </MDBox>
                  ))}
                </MDBox>
              </InfiniteScroll>
            </Grid>

            {/* <Grid item lg={2}>
              <></>
            </Grid> */}
            {isDesktopOrLaptop && (
              <Grid item xs={12} xl={4}>
                <SuggestionList
                  title="Suggestions for you"
                  // profiles={suggestionList}
                  shadow={false}
                  // update={() => suggestionListUpdate()}
                />
                <MDBox>
                  <Footer />
                </MDBox>
              </Grid>
            )}
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Notifications;

// <Grid item xs={12} lg={8}>
//     <Card>
//       <MDBox p={2} lineHeight={0}>
//         <MDTypography variant="h5">Notifications</MDTypography>
//         <MDTypography variant="button" color="text" fontWeight="regular">
//           Notifications on this page use Toasts from Bootstrap. Read more details here.
//         </MDTypography>
//       </MDBox>
//       <MDBox p={2}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} sm={6} lg={3}>
//             <MDButton variant="gradient" color="success" onClick={openSuccessSB} fullWidth>
//               success notification
//             </MDButton>
//             {renderSuccessSB}
//           </Grid>
//           <Grid item xs={12} sm={6} lg={3}>
//             <MDButton variant="gradient" color="info" onClick={openInfoSB} fullWidth>
//               info notification
//             </MDButton>
//             {renderInfoSB}
//           </Grid>
//           <Grid item xs={12} sm={6} lg={3}>
//             <MDButton variant="gradient" color="warning" onClick={openWarningSB} fullWidth>
//               warning notification
//             </MDButton>
//             {renderWarningSB}
//           </Grid>
//           <Grid item xs={12} sm={6} lg={3}>
//             <MDButton variant="gradient" color="error" onClick={openErrorSB} fullWidth>
//               error notification
//             </MDButton>
//             {renderErrorSB}
//           </Grid>
//         </Grid>
//       </MDBox>
//     </Card>
//   </Grid>
